// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bd753d38","455":"60831887","977":"6835222f"}[chunkId] + ".chunk.js";
};